import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view event whenever the SPA route changes.
// The base gtag script is loaded in /public/index.html with send_page_view:false,
// so we control page views client-side for accurate per-route analytics.
const GA_ID = "G-6PXQ9786BP";

export default function AnalyticsTracker() {
    const loc = useLocation();
    useEffect(() => {
        if (typeof window === "undefined" || typeof window.gtag !== "function") return;
        const path = loc.pathname + loc.search;
        window.gtag("event", "page_view", {
            page_path: path,
            page_location: window.location.href,
            page_title: document.title,
            send_to: GA_ID,
        });
    }, [loc.pathname, loc.search]);
    return null;
}
